import { GET_VEHICLES_API } from '../utils/api';

export const LOAD_VEHICLE_REQUEST = '@vehicles/LOAD_VEHICLE_REQUEST';
export const RESET_VEHICLE_REQUEST = '@vehicles/RESET_VEHICLE_REQUEST';
export type VEHICLE_REQUEST = typeof LOAD_VEHICLE_REQUEST;
export type RESET_REQUEST = typeof RESET_VEHICLE_REQUEST;


export interface LoadVehicle {
  type: VEHICLE_REQUEST;
  payload: {
    vehicles: null,
  }
}

export interface zeroVehicle {
  type: RESET_REQUEST;
  payload: {
    vehicles: null,
  }
}


export async function loadVehicle(): Promise<LoadVehicle> {
  try {
    const response = await GET_VEHICLES_API();
    return {
      type: LOAD_VEHICLE_REQUEST,
      payload: {
        vehicles: response.data
      }
    };
  } catch (error) {
    return { 
      type: LOAD_VEHICLE_REQUEST, 
      payload: {
        vehicles: Object(error)
      }
    }
  }
}

export function resetVehicle(): zeroVehicle {
  return {
    type: RESET_VEHICLE_REQUEST,
    payload: {
      vehicles: null
    }
  }
}
